export interface MarkerPosition {
  percentX: number;
  percentY: number;
}

export function getImageFitBounds(img: HTMLImageElement, containerWidth: number, containerHeight: number) {
  const imageAspect = img.naturalWidth / img.naturalHeight || containerWidth / containerHeight;
  const containerAspect = containerWidth / containerHeight;
  let displayedWidth: number, displayedHeight: number, offsetX: number, offsetY: number;

  if (imageAspect > containerAspect) {
    displayedWidth = containerWidth;
    displayedHeight = containerWidth / imageAspect;
    offsetX = 0;
    offsetY = (containerHeight - displayedHeight) / 2;
  } else {
    displayedHeight = containerHeight;
    displayedWidth = containerHeight * imageAspect;
    offsetX = (containerWidth - displayedWidth) / 2;
    offsetY = 0;
  }

  return { offsetX, offsetY, displayedWidth, displayedHeight };
}

export function getMarkerPosition(img: HTMLImageElement, position: MarkerPosition) {
  const { offsetX, offsetY, displayedWidth, displayedHeight } =
    getImageFitBounds(img, img.clientWidth, img.clientHeight);

  return {
    left: ((offsetX + position.percentX * displayedWidth) / img.clientWidth) * 100,
    top: ((offsetY + position.percentY * displayedHeight) / img.clientHeight) * 100,
  };
}
